import styled from 'styled-components';

export const Container = styled.div`
  .small-icon {
    font-size: 0.9rem;
  }
`;
